"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuiltForRealAthletes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  return <section data-section-id="232850" id="women-girls-pathway" className="bg-background text-foreground w-full relative overflow-hidden border-y border-border/10">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[80vh] lg:min-h-[90vh]">
        {}
        <div className="relative h-[50vh] lg:h-auto overflow-hidden group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/women_football_pathway_action.png" alt="WT Birkalla women's player in action showing elite development" className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-1000 group-hover:scale-105" />
          {}
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent lg:hidden" />
          {}
          <div className="absolute top-0 right-0 w-[2px] h-full bg-primary/30 hidden lg:block" />
        </div>

        {}
        <div className="flex flex-col justify-center p-8 md:p-16 lg:p-20 xl:p-32 relative z-10 bg-background">
          <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <div className="w-16 h-1.5 bg-primary mb-8 shadow-[0_0_15px_rgba(234,179,8,0.5)]" />

            <h2 className="font-default text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black uppercase tracking-tighter leading-[0.85] mb-8 text-foreground">
              Elite<br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
                Girls Pathway
              </span>
            </h2>

            <p className="text-muted-foreground text-lg md:text-xl max-w-lg mb-12 font-medium leading-relaxed">
              From MiniRoos to the Senior First Team, our structured development program empowers female athletes to reach their full potential on and off the pitch.
            </p>

            <Button asChild size="lg" className="w-fit h-14 px-10 text-lg font-bold uppercase tracking-widest hover:scale-105 transition-transform duration-300 shadow-lg shadow-primary/20 bg-primary text-primary-foreground">
              <Link to="/JuniorAcademyPage">Explore the Journey</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}